// import { FormBaseProps, InputField, FormSubmitCallback, SelectField } from "../../../components/Reusable/Form";
import { z } from "zod"
import { FieldProps } from "react-final-form";
import { useEffect, useState } from "react";
import { FormBase, FormBaseProps, InputField, CheckboxField, FormSubmitCallback, SelectField } from "ui";
import { CompanyType } from "../../__generated__/graphql";
import { splitEnumToDisplayCase } from "../../tools/splitEnumToDisplayCase";
import { useLocation } from "react-router";
const companyTypes = [
    {
        value: CompanyType.Default,
        label: splitEnumToDisplayCase(CompanyType.Default)
    },
    {
        value: CompanyType.School,
        label: splitEnumToDisplayCase(CompanyType.School)
    },
    {
        value: CompanyType.PrivateClinic,
        label: splitEnumToDisplayCase(CompanyType.PrivateClinic)
    },
    {
        value: CompanyType.Hospital,
        label: splitEnumToDisplayCase(CompanyType.Hospital)
    }, {
        value: CompanyType.Other,
        label: splitEnumToDisplayCase(CompanyType.Other)
    }
]
export const COMPANY_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        "name": "name",
        "label": "Company Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 4,
        },
    },
    {
        "name": "abbrv",
        "label": "Abbreviation",
        component: InputField,
        fullWidth: true,
        grid: {
            xs: 4,
        },
    },
    {
        "name": "type",
        "label": "Company Type",
        component: SelectField,
        options: companyTypes,
        grid: {
            xs: 4
        }
    },
    {
        "name": "needParentalConsent",
        "label": "Parental Consent Needed",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
    {
        "name": "autoParentalConsent",
        "label": "Send Parental Consent Automatically",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        },
        showIf: (values: any) => values.needParentalConsent === true
    },
    {
        "name": "timeoutWindow",
        "label": "Time out Window",
        component: InputField,//NEED BOOLEAN FIELD
        helperText: "Time out in days",
        type: "number",
        grid: {
            xs: 4
        },
        showIf: (values: any) => values.needParentalConsent === true
    },
    {
        "name": "abuseAtHome",
        "label": "Abuse At Home Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
    {
        "name": "safeAtHome",
        "label": "Safe at Home Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
    {
        "name": "suicide",
        "label": "Suicide Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
]

export const companyEditSchema = z.object({
    name: z.string().trim().nonempty().max(255),
    abbrv: z.string().trim().max(25).nullish(),
    type: z.string().trim().nonempty().max(255),
    needParentalConsent: z.boolean(),
    autoParentalConsent: z.boolean(),
    timeoutWindow: z.coerce.number().int().nullable(),
    abuseAtHome: z.boolean(),
    safeAtHome: z.boolean(),
    suicide: z.boolean(),
    paidUsers: z.coerce.number().int().nullable(),
})

export type CompanyFormSchema = z.infer<typeof companyEditSchema>;

type FormState = {
    fields: FieldProps<string, any>[];
}

export type CompanyFormProps = {
    onSubmit: (values: CompanyFormSchema) => Promise<ReturnType<FormSubmitCallback>>,
    onCancel: () => void,
    isDevPortal: boolean
} & Pick<FormBaseProps<CompanyFormSchema>, "initialValues" | "readonly">

export default function CompanyForm({ initialValues, readonly, onSubmit, onCancel, isDevPortal }: CompanyFormProps) {
    const [formState, setFormState] = useState<FormState>({
        fields: COMPANY_FORM_FIELDS
    })
    useEffect(() => {
        if (isDevPortal) {
            setFormState((prevState) => {
                const fields = [...COMPANY_FORM_FIELDS]
                fields.push(
                    {
                        "name": "paidUsers",
                        "label": "Paid Licenses",
                        type: "number",
                        component: InputField,//NEED BOOLEAN FIELD                      
                        grid: {
                            xs: 4
                        }
                    },
                )
                return {
                    ...prevState,
                    fields
                }
            })
        }
    }, [])
    const CompanyForm = FormBase<CompanyFormSchema>({
        fields: formState.fields,
        initialValues: initialValues ?? {},
        validationSchema: companyEditSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        readonly,
        onSubmit: onSubmit,
        onCancel: onCancel
    })
    return CompanyForm
}